import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YardMapConfigurationRoutingModule } from './yard-map-configuration.routing-module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StationAssignmentDetailsComponent } from './component/station-assignment-details/station-assignment-details.component';
import { MapDetailsComponent } from './component/map-details/map-details.component';
import { YardMapConfigurationComponent } from './component/yard-map-configuration/yard-map-configuration.component';
import { ColorPickerModule } from 'src/tmc-common/components/color-picker/color-picker.module';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    SharedModule,
    YardMapConfigurationRoutingModule,
    ColorPickerModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  declarations: [
    YardMapConfigurationComponent,
    StationAssignmentDetailsComponent,
    MapDetailsComponent
  ]
})
export class YardMapConfigurationModule { }
